/* eslint-disable */
var $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'flag-user',
  components: {},
  props: ['userFlagID','userFlagStatus','page'],
  data () {
    return {
      flag_remark:'',
      userUserId:'',
      submitted: false
    }
  },
  computed: {

  },
  mounted () {
    this.user
  },
  methods: {
    getUserListAgain() {
      this.$store.dispatch('getUserListDetails').then((res) => {}).catch((err) => {})
    },
    PopupClose(){
      bus.$emit('UserFlagPopupBus', false);
    },
    userFlagConfirmation(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          this.$store.dispatch('UpdateUserFlagStatusById', {
            data: {
              id: this.userFlagID,
              is_flagged: this.userFlagStatus,
              flag_remark: this.flag_remark
            }
          }).then((res) => {
            if (res.status == '200') {
              this.flag_remark = ''
              if(this.page == 'UserList'){
                bus.$emit('UserFlagPopupBus', false);
                this.getUserListAgain()
              } else {
                bus.$emit('UserFlagPopupBus', {show:false, refresh:true});
              }
              toast.success(res.data.msg);
            }
          }).catch((err) => {
            toast.error(err.data.msg);

          })
        }
      })
    }
  }
}
